

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 21"}, rest), ["\n  ", h('path', {"fill":"currentColor","fill-rule":"evenodd","d":"M9 1.75c-.552 0-1 .392-1 .875V3.5h4v-.875c0-.483-.448-.875-1-.875H9Zm5 1.75v-.875C14 1.175 12.657 0 11 0H9C7.343 0 6 1.175 6 2.625V3.5H1c-.552 0-1 .392-1 .875s.448.875 1 .875h.105l1.703 13.415C2.977 19.995 4.261 21 5.79 21h8.42c1.529 0 2.813-1.005 2.981-2.335L18.895 5.25H19c.552 0 1-.392 1-.875s-.448-.875-1-.875h-5Zm2.883 1.75H3.117l1.679 13.221c.057.444.485.779.994.779h8.42c.509 0 .937-.335.994-.779L16.883 5.25ZM8 7.875c.552 0 1 .392 1 .875v7c0 .483-.448.875-1 .875s-1-.392-1-.875v-7c0-.483.448-.875 1-.875Zm4 0c.552 0 1 .392 1 .875v7c0 .483-.448.875-1 .875s-1-.392-1-.875v-7c0-.483.448-.875 1-.875Z"}, []), "\n"]);
};

        